module.exports = __webpack_public_path__ + "img/youtube.dcb38968.svg";